import React from 'react'
import flowRight from 'lodash/flowRight'
import withDialog from 'shared/hocs/withDialog'
import styled from 'styled-components'
import Box from 'shared/components/Box'
import { useSelector } from 'react-redux'
import { organizationSettingSelector } from 'shared/hocs/withAuth'

type SupportDialogProps = {
  supportSubject: string
}

function Support(props: SupportDialogProps) {
  const { supportSubject } = props
  const { organization_information } = useSelector(organizationSettingSelector)
  return (
    <ConfirmationDialogBodyContainer className="confirm-dialog-container">
      {organization_information.support_email && (
        <Box className="description">
          Please contact{' '}
          <a
            href={`mailto:${organization_information.support_email}?subject=${
              supportSubject ? supportSubject : 'Contact Support'
            }`}
          >
            {organization_information.support_email}
          </a>{' '}
          for support.
        </Box>
      )}
    </ConfirmationDialogBodyContainer>
  )
}

const SupportDialog = flowRight(withDialog())(Support)

const ConfirmationDialogBodyContainer = styled(Box)`
  padding: 40px 40px 0;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`

export default SupportDialog
